import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';

export type SparksFooterProps = {
    onNeedSupportClick?: () => void;
};

export function SparksFooter({ onNeedSupportClick }: SparksFooterProps) {
    const { t } = useTranslation('sparks');

    return (
        <div className="flex shrink-0 flex-col items-end px-3.5 pb-3.5">
            <p className="mb-3 mt-3 w-full text-center font-GMedium text-[10px] leading-3 tracking-tight text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('disclaimer')}
            </p>
            <button
                type="button"
                onClick={onNeedSupportClick}
                className="flex items-center gap-1 rounded-full border border-icoGray-300 px-2 py-1.5 font-GSemiBold text-[10px] leading-3 tracking-tight text-icoBlack transition-colors hover:bg-icoGray-100 dark:border-icoDarkMode-beton dark:text-white dark:hover:bg-icoDarkMode-anthracite">
                <Icon icon="headphone" className="text-xs" />
                <span>{t('need_support')}</span>
            </button>
        </div>
    );
}
